import React from 'react';
import { compose } from 'recompose';

import TextBox from 'devextreme-react/text-box';

import { Typography, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { areEqual } from '../../../../utilities';

function Field({ classes, value, handleChange, name, disabled }) {
  const { numberBox } = classes;

  // function onFocusOut(event) {
  //   const changedValue = event?.component?._changedValue;
  //   if (changedValue && parseFloat(changedValue) !== value) {
  //     handleChange(parseFloat(changedValue), name);
  //   }
  // }

  return (
    <TextBox
      defaultValue={'0'}
      value={value}
      // onFocusOut={onFocusOut}
      className={numberBox}
      disabled={disabled}
      readOnly
    />
  )
}

function DistanceMeasuringDetail({ classes, disabled, totalArea, totalDistance }) {
  const { editorContainer, editorTitle, fieldWrapper } = classes;

  function handleManualChange(value, fieldName) {}

  return (
    <>
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Total Distance
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={totalDistance}
            name="totalDistance"
            disabled={disabled}
          />
        </div>
      </div>
      <Divider />
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Total Area
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={totalArea}
            name="totalArea"
            disabled={disabled}
          />
        </div>
      </div>
      <Divider />
    </>
  )
}

const styles = () => ({
  editorContainer: {
    padding: '8px 24px 16px'
  },
  editorTitle: {
    marginLeft: -8,
    marginBottom: 4,
    fontSize: '1rem'
  },
  numberBox: {
    width: '51%',
    '& .dx-texteditor-input-container': {
      paddingLeft: '0.5rem',
    }
  },
  fieldWrapper: {
    display: 'flex'
  }
});

export default compose(withStyles(styles))(React.memo(DistanceMeasuringDetail, areEqual));
